import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    window.currentProjectId = this.element.dataset.projectId
    window.currentUserId = this.element.dataset.userId
    window.slideDesignPlanningOrigin = {
      present: this.element.dataset.planningOriginPresent === 'true',
      id: this.element.dataset.planningOriginId ? Number(this.element.dataset.planningOriginId) : null,
      name: this.element.dataset.planningOriginName || '',
      path: this.element.dataset.planningOriginPath || ''
    }

    window.selectedCategory = 'design'

    const savedImageModel = localStorage.getItem('selectedSlideImageModel') || window.selectedImageModel || ''
    window.selectedImageModel = savedImageModel
    window.selectedSlideImageModel = savedImageModel

    const isFreshProject = this.element.dataset.projectFresh === 'true'
    if (isFreshProject) {
      localStorage.setItem('selectedChatMode', 'ui_only')
    }

    const savedMode = localStorage.getItem('selectedChatMode')
    const savedAiMode = localStorage.getItem('selectedAiMode')

    if (savedMode) {
      window.selectedMode = savedMode
      const radio = document.querySelector(`input[name="chat-mode"][value="${savedMode}"]`)
      if (radio) radio.checked = true
    }

    if (savedAiMode) {
      window.selectedAiMode = savedAiMode
      const label = document.getElementById('ai-mode-label')
      if (label) label.textContent = savedAiMode.toUpperCase()
    }

    this._setupProjectNameInput()

    if (!window.__slideDesignLoaded) {
      window.__slideDesignLoaded = true
      this._loadEditorModules()
    }
  }

  disconnect() {
    window.__slideDesignLoaded = false
  }

  _setupProjectNameInput() {
    const input = document.getElementById('project-name-input')
    if (!input) return

    input.addEventListener('blur', async () => {
      const newName = input.value.trim()
      if (!newName || !window.currentProjectId) return

      try {
        if (window.ProjectManager && typeof window.ProjectManager.updateProjectName === 'function') {
          await window.ProjectManager.updateProjectName(window.currentProjectId, newName)
          document.title = `${newName} - Slide Design`
        }
      } catch (e) {
        console.error('[SlideDesignEditor] 프로젝트명 업데이트 오류:', e)
      }
    })

    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault()
        this.blur()
      }
      if ((e.metaKey || e.ctrlKey) && e.key === 'a') {
        e.preventDefault()
        this.select()
      }
    })
  }

  async _loadEditorModules() {
    if (typeof window.jQuery !== 'undefined') {
      window.$ = window.jQuery
    }
    try {
      await import('/js/slide-design/index.js?v=' + Date.now())
    } catch (e) {
      console.error('[SlideDesignEditor] 에디터 모듈 로드 실패:', e)
    }
  }
}
